import React from "react";

const RoleOutlet = ({roles, component: Component}) => {
  const role = "admin";
  const canAccess = roles.includes(role);
  return canAccess ? <Component></Component> : <></>;
};
export default RoleOutlet;
